var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInIconLst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "inIconLst_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 462",
    transform: "translate(.083)",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h72v72H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "inIconLst_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 461",
    fill: "none",
    d: "M0 0h72v72H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.083)",
    clipPath: "url(#inIconLst_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "InIcon",
    transform: "translate(.083)",
    clipPath: "url(#inIconLst_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 418"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 551",
    d: "M9.703 24.568l3.174.216q-.239 1.392-.382 2.088h5.536v3.168a11.285 11.285 0 002.029 1.728v-6.936h3.2v9.216a36.275 36.275 0 004.772 2.688l-1.671 2.976a19.718 19.718 0 01-3.1-1.8v8.112h-3.2v-10.44l-1.152-.912q-.214-.191-1.384-1.2a17.853 17.853 0 01-2.744 7.272 17.8 17.8 0 01-4.028 4.06 15.355 15.355 0 01-2.434 1.508L6.148 43.48a13.777 13.777 0 003.627-1.992 8.864 8.864 0 002.577-2.9q-.191-.24-1.1-1.536-.286-.408-1.551-1.872a20.175 20.175 0 01-1.792 2.924l-2-2.76a23.52 23.52 0 002.792-5.928 23.951 23.951 0 001-4.848m5.2 5.16h-3.1q-.43 1.416-.907 2.736a32.524 32.524 0 012.915 3.168 13.943 13.943 0 00.836-3.192 22.682 22.682 0 00.264-2.712",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 739",
    d: "M42.578 52.844h20.245a3 3 0 100-6H42.578a7.513 7.513 0 01-7.508-7.5v-.906a7.512 7.512 0 017.508-7.5h15.84a3 3 0 100-6h-15.84a13.522 13.522 0 00-13.515 13.5v.906a13.523 13.523 0 0013.515 13.5",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 740",
    d: "M62.989 30.938a3 3 0 001.932-5.3L51.839 14.68a3.002 3.002 0 10-3.86 4.6L61.06 30.24a2.994 2.994 0 001.929.7",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 741",
    d: "M49.906 41.898a2.992 2.992 0 001.929-.7l13.081-10.96a3.002 3.002 0 10-3.86-4.6L47.979 36.6a3 3 0 001.927 5.298",
    fill: "#040000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInIconLst);
export default __webpack_public_path__ + "static/media/inIconLst.2b3b1384c2559b0f.svg";
export { ForwardRef as ReactComponent };